import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
export class AddLeverantorsorderradCommand extends BasicCommand<AddLeverantorsorderradCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<AddLeverantorsorderradCommand>;

    leverantorsorderId: number;
    handelssortimentsgrupp: number;
    kvantitet: number;
    periodTom: string;
    periodFrom: string;
    egenBefraktning: boolean;
    mattslag: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "AddLeverantorsorderradCommand";

    constructor(leverantorsorderId: number) {
        super("AddLeverantorsorderradCommand", "leverantorsorderrad", CommandType.Insert);
        this.leverantorsorderId = leverantorsorderId;
    }
}
